import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
import { useCurrency } from '../utils/currency';
export function BonusesHeroSection() {
  const {
    formatPrice
  } = useCurrency();
  return <section className="relative w-full bg-white pt-14 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-87">
      {/* Subtle background texture */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_#DCF8C620_0%,_transparent_60%)] pointer-events-none" data-id="element-88" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center relative z-10" data-id="element-89">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.65,
        ease: 'easeOut'
      }} className="flex flex-col gap-6 text-center lg:text-left order-2 lg:order-1" data-id="element-90">
          {/* Badge */}
          <div className="flex justify-center lg:justify-start" data-id="element-91">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#0B6B3A]/10 text-[#0B6B3A] font-semibold rounded-full border border-[#0B6B3A]/20 text-[16px]" data-id="element-92">
              <Zap className="w-3.5 h-3.5" data-id="element-93" />
              Mapa 5R: Cierre por DM y WhatsApp
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-[3.25rem] font-bold text-[#1A1A1A] leading-[1.1] tracking-tight" data-id="element-94">
            Junto al Mapa 5R recibes{' '}
            <span className="text-[#0B6B3A]" data-id="element-95">3 bonos</span> (valorados en{' '}
            <span className="relative inline-block" data-id="element-96">
              <span className="relative z-10" data-id="element-97">{formatPrice(47)}</span>
              <span className="absolute bottom-1 left-0 w-full h-2 bg-[#DCF8C6] -z-0 rounded" data-id="element-98" />
            </span>
            ) completamente gratis
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-[#6B7280] leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-99">
            Porque no sirve de nada tener scripts de cierre si no sabés filtrar
            curiosos, pedir el pago sin incomodar y reactivar chats fríos.
          </p>

          {/* Microcopy */}
          <p className="text-sm text-[#0B6B3A] font-medium tracking-wide uppercase" data-id="element-100">
            Acceso inmediato. Sin suscripción.
          </p>

          {/* CTA */}
          <div className="pt-2" data-id="element-101">
            <a href="#comprar" className="inline-flex items-center justify-center gap-2 bg-[#0B6B3A] hover:bg-[#095c32] text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 w-full sm:w-auto" data-id="element-102">
              Si, Quiero mi Mapa 5R.
            </a>
            <p className="mt-3 text-sm text-[#6B7280]" data-id="element-103">
              Precio de lanzamiento · Subira de valor en los proximos dias,
              aprovecha ahora.
            </p>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 24,
        scale: 0.97
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} transition={{
        duration: 0.65,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-sm lg:max-w-full order-1 lg:order-2" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/xcAntiqM4w3mUyViNuthK5/mockup_producto.png" alt="Mapa 5R: Cierre por DM y WhatsApp — Mockup del producto" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-105" />
        </motion.div>
      </div>
    </section>;
}